import { AuthManager } from "utils/AuthManager"
import { piiRedactedAccounts } from "utils/constants"

export const isPIIRedactionEnabled = () => {
  const email = AuthManager.getAuthInfo()?.user.email
  return !!email && piiRedactedAccounts.includes(email)
}

export const redactPII = <T extends string | null | undefined>(value: T): T => {
  if (!value) return value
  return `${value.slice(0, 2).toUpperCase()}xxxxxx` as T
}
